// Roteamento backend (prod vs local). Importe daqui em vez de ``utils/utils``.
//
// Estados em dev:
//   1. useProductionBackend = true                                  -> tudo em prod
//   2. useProductionBackend = false + useProductionForStatusReads = true
//      -> writes em local, GETs de inputs (V2 + V3) em prod (debug perf)
//   3. useProductionBackend = false (default)                       -> tudo em local
//
// Em build de producao, as flags sao ignoradas — sempre prod.

export const useProductionBackend = false;

// Modo hibrido: quando o backend principal e o local, redireciona GETs
// de ``api/inputs_*`` (V2) e ``api/v3/...`` (V3) para producao.
export const useProductionForStatusReads = false;

export const productionUrl = "https://api.profit-insights.int.digital/";
export const localUrl = "http://localhost:8000/";

export const baseUrl =
  process.env.NODE_ENV &&
  process.env.NODE_ENV === "development" &&
  !useProductionBackend
    ? localUrl
    : productionUrl;

const INPUT_STATUS_URL_FRAGMENTS = ["api/inputs_", "api/v3/"];
const LOCAL_ONLY_URL_FRAGMENTS = ["api/v3/maintenance/"];
const READ_HTTP_METHODS = new Set(["get", "head"]);

// Devolve o baseURL alternativo para uma request, ou null para manter o
// default. Aplica a regra do modo hibrido (estado 2 acima).
export function resolveBaseUrlFor(url, method) {
  if (!useProductionForStatusReads) return null;
  if (useProductionBackend) return null;
  if (!url) return null;
  if (LOCAL_ONLY_URL_FRAGMENTS.some((f) => url.includes(f))) return null;
  if (!READ_HTTP_METHODS.has((method || "get").toLowerCase())) return null;
  if (!INPUT_STATUS_URL_FRAGMENTS.some((f) => url.includes(f))) return null;
  return productionUrl;
}
